export function sum(numbers: number[]): number {
  return numbers.reduce(
    (summedNumbers, currentNumber) => (summedNumbers += currentNumber),
    0
  );
}

export function toMillion(n: number): number {
  return n ? n * 1000 : 0;
}
